import { __ } from './I18n';

const Countries = [
  {
    text: __('Brasil'),
    value: 'br',
    key: 'br'
  },
  {
    text: __('Estados Unidos'),
    value: 'eua',
    key: 'eua'
  },
];

export default Countries;
